import { ReedState } from '../types';

export const initial: ReedState = {
  recentReeds: [],
  discardedReeds: [],
  reeds: {},
};
